{"id":"Cart.BonusPointsBox","prefabs":{"default":{"children":[{"component":"Cart.BonusPointsBox","options":"options:*"}]}}}